<template>
  <span class="text-sm secondary_color p-4">
    {{ value || placeholder }}
  </span>
</template>

<script setup>
const props = defineProps({
  value: {
    type: String,
    default: null,
  },
  placeholder: {
    type: String,
    required: true,
  },
  row: {
    type: Object,
    default: () => ({}),
  },
});
</script>
